import { costMonthKey } from "@/lib/signal-agent-calc";
import type { CrmCostSummary } from "@/hooks/use-crm-costs";

const MONTH_NAMES = [
  "januar", "februar", "mars", "april", "mai", "juni", "juli", "august", "september", "oktober", "november", "desember",
];

/** 'YYYY-MM' til «november 2026». */
export function monthLabel(month: string): string {
  const [y, m] = month.split("-");
  return `${MONTH_NAMES[Number(m) - 1] ?? m} ${y}`;
}

/** De siste `count` månedene (nyeste først) som velgerverdier, regnet i Oslo-tid. */
export function monthOptions(now: Date, count = 12): { value: string; label: string }[] {
  const [y, m] = costMonthKey(now).split("-").map(Number);
  return Array.from({ length: count }, (_, i) => {
    const d = new Date(Date.UTC(y, m - 1 - i, 1));
    const value = `${d.getUTCFullYear()}-${String(d.getUTCMonth() + 1).padStart(2, "0")}`;
    return { value, label: monthLabel(value) };
  });
}

/** Andel feilede kjøringer (0 til 1), eller null uten kjøringer. */
export function failureShare(summary: Pick<CrmCostSummary, "runs" | "failed_runs">): number | null {
  return summary.runs > 0 ? summary.failed_runs / summary.runs : null;
}
